/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { openDB } from "idb";
import ItemsTable from "./ItemsTable";
import formStyles from "../css/SetupForm.module.css";
import searchStyles from "../css/SetupPage.module.css";

const DEFAULT_ITEMS = [
  {
    _id: "61b5ba72a6ecaaa27b739012",
    brand_uuid: "brand-uuid-1",
    category_uuid: "category-uuid-1",
    item_mode: "1",
    item_name: "Farm House Pizza",
    item_uuid: "item-uuid-1",
    inventory_details: {
      is_saleable: "",
      sales_unit: "",
      primary_unit_name: "",
      inventory_reduction_at: "Sales/Processing",
    },
    units: [
      {
        unit_name: "",
        unit_numerator: "",
        unit_denominator: "",
        unit_status: "",
      },
      {
        unit_name: "",
        unit_numerator: "",
        unit_denominator: "",
        unit_status: "",
      },
    ],
    outlet_wise_item_details: [
      {
        inventory_details: { ingredients: [], units: [] },
        other_details: {
          availability_last_updated_at: "2000-01-01T00:00:00.000Z",
          item_availability: "1",
          item_code: "code1",
          item_kot_name: "abc",
          item_gst: "5",
          item_vat: "10",
          item_cess: "",
          item_status: "1",
          item_excluded_from_discount: "1",
          item_excluded_from_charge: "1",
          item_parcel_type: "2",
        },
        _id: "61e3daa107ff0d681d8e0692",
        warehouse_inventory: [],
        outlet_uuid: "outlet-uuid-1",
        maintain_inventory: "",
        ingredients: [
          { item_uuid: "", qty: "", unit: "" },
          { item_uuid: "", qty: "", unit: "" },
        ],
      },
    ],
    warehouse_opening: [
      { warehouse_uuid: "", inventory: "", fin_uuid: "" },
      { warehouse_uuid: "", inventory: "", fin_uuid: "" },
    ],
    UUID: "item-uuid-1",
  },
];

export default function ItemsForm({
  itemGroupings,
  setItemGroupings,
  itemGroupingIndex,
  setItemsModalIndex,
}) {
  const [pattern, setPattern] = useState("");
  const [items, setItems] = useState(DEFAULT_ITEMS);
  const searchedItems = useMemo(
    () =>
      items?.filter((item) =>
        item.item_name.toLowerCase().includes(pattern.toLowerCase())
      ),
    [pattern, items, itemGroupings]
  );
  const includesArray = useMemo(
    () =>
      searchedItems.map((item) =>
        itemGroupings[itemGroupingIndex]?.items?.includes(item.item_uuid)
      ),
    [searchedItems]
  );
  const occurrencesArray = useMemo(
    () =>
      searchedItems.map(
        (item) =>
          itemGroupings.filter((itemGroup) =>
            itemGroup.items?.includes(item.item_uuid)
          ).length
      ),
    [searchedItems]
  );

  useEffect(() => {
    const getItemsData = async () => {
      const db = await openDB(
        "FoodDo",
        +localStorage.getItem("IDBVersion") || 1
      );
      const itemStore = db.transaction("item", "readonly").objectStore("item");
      const items = await itemStore.getAll();
      setItems(items);
    };
    getItemsData();
  }, []);

  const handleItemIncludeToggle = (index) => {
    const updatedItemGroupings = itemGroupings.slice();
    const updatedItems = toggleArrayItem(
      updatedItemGroupings[itemGroupingIndex].items,
      searchedItems[index].item_uuid
    );
    updatedItemGroupings[itemGroupingIndex].items = updatedItems;
    setItemGroupings(updatedItemGroupings);
  };

  const toggleArrayItem = (arr, item) =>
    arr.includes(item) ? arr.filter((i) => i !== item) : [...arr, item];

  return (
    <div
      className={formStyles.noSpaceForm}
      style={{
        padding: "0px 12px",
        height: "fit-content",
      }}>
      <h1>Items</h1>

      <input
        type='text'
        onChange={(e) => setPattern(e.target.value)}
        value={pattern}
        placeholder='Search...'
        className={searchStyles.searchInput}
      />

      <ItemsTable
        items={searchedItems}
        occurrencesArray={occurrencesArray}
        onItemIncludeToggle={handleItemIncludeToggle}
        includesArray={includesArray}
      />
      <div onClick={() => setItemsModalIndex(null)}>
        <button type='button' className='savebtn'>
          Done
        </button>
      </div>
    </div>
  );
}
